import React from 'react'
import { useSharedStyles } from '../../Settings/useSharedStyles'
import { Box, Typography } from '@mui/material'
import { Profile } from '@/shared/ui/Icons'
import { DataLine } from '../../../components/settings/components/DataLine'
import { Edit } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

const ProfileSection = () => {
    const { t: translate } = useTranslation()
    const {
        titleStyle,
        titleContainer,
        sectionStyle,
        iconContainer,
        dataContainer,
    } = useSharedStyles()
    return (
        <Box sx={sectionStyle}>
            <Box sx={titleContainer}>
                <Box sx={iconContainer}>
                    <Profile />
                </Box>
                <Typography ml="24px" sx={titleStyle}>
                    {translate('info')}
                </Typography>
            </Box>
            <Box sx={dataContainer}>
                <DataLine fieldName="nameAndSurname" value="Jan Kowalski" />
                <DataLine fieldName="id" value="986653" />

                <Box display="flex" columnGap="8px">
                    <DataLine fieldName="email" value="986653" /> <Edit />
                </Box>
                <Box display="flex" columnGap="8px">
                    <DataLine
                        fieldName="password"
                        value="986653"
                        type="password"
                    />
                    <Edit />
                </Box>
            </Box>
        </Box>
    )
}

export default ProfileSection
